import React from "react";
import Modal from "react-bootstrap/Modal";
import { DataGrid } from '@mui/x-data-grid';
import Button from "react-bootstrap/Button";

export default function MaterialList({
  _materialList,
  showMaterialList,
  setShowMaterialList,
  materialFieldName,
  onChange,
}) {


  function handleOnSelect(selectedId) {
    onChange({
      target: { value: selectedId[0], name: materialFieldName, type: "text"  },
    });
    setShowMaterialList(false);
  } 
  return (
    <Modal
      show={showMaterialList}
      size="xl"
      onHide={() => setShowMaterialList(false)}
      dialogClassName="modal-90w modal-dialog-scrollable"
      aria-labelledby="example-custom-modal-styling-title"
      className="partner-list-modal"
    >
      <Modal.Header
        style={{
          background: "#d4e1f5",
        }}
      >
        <Modal.Title
          id="example-custom-modal-styling-title"
          style={{
            fontWeight: 700,
          }}
        >
          List of Materials
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {_materialList?.length && (
          <div style={{ height: '50vh', width: '100%' }}>
         <DataGrid
         rows={_materialList || []}
         columns={[
          { field: 'id', headerName: 'Material ID', width: 250 },
          { field: 'code', headerName: 'Code', width: 250 },
          { field: 'name', headerName: 'Name', width: 350 },
          { field: 'materialTypeId', headerName: 'Material Type', width: 200 },
         ]}
         pageSize={10}
         rowsPerPageOptions={[5]}
         onSelectionModelChange={selectedId => handleOnSelect(selectedId)}
       />
       </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <div className="offset-11 col-1">
          <Button
            variant="danger"
            onClick={() => {
              setShowMaterialList(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
